import { render, staticRenderFns } from "./ResetZoomControl.vue?vue&type=template&id=720864a4&"
import script from "./ResetZoomControl.vue?vue&type=script&lang=js&"
export * from "./ResetZoomControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports